var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedeemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 111,
    viewBox: "0 0 93 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 49.5781C93 75.25 72.1913 96.043 46.5 96.043C20.8088 96.043 0 75.25 0 49.5781",
    fill: "#F9B067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0488 34.4775C84.0488 55.2009 67.239 71.9979 46.5 71.9979C25.761 71.9979 8.95126 55.2009 8.95126 34.4775",
    fill: "#F9B067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6788 20.3984C75.6788 36.3824 62.7053 49.3228 46.7325 49.3228C30.7598 49.3228 17.7863 36.3824 17.7863 20.3984",
    fill: "#F9B067"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.169 8.89746C67.169 20.1884 58.0085 29.3188 46.7323 29.3188C35.456 29.3188 26.2955 20.1652 26.2955 8.89746",
    fill: "#F9B067"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5195 0C58.5195 6.50509 53.2418 11.7789 46.7318 11.7789C40.2218 11.7789 34.944 6.50509 34.944 0",
    fill: "#F9B067"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2525 78.665C6.46353 84.4499 9.27678 103.686 28.8068 99.7369",
    stroke: "#F9B067",
    strokeWidth: 5.7375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3095 98.5759C89.0245 105.081 87.862 82.0808 81.6775 76.8535",
    stroke: "#F9B067",
    strokeWidth: 5.7375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6615 79.7803V109.541",
    stroke: "#F9B067",
    strokeWidth: 5.7375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3385 79.8506V109.611",
    stroke: "#F9B067",
    strokeWidth: 5.7375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5905 56.7777C53.5905 56.7777 47.778 60.7272 41.7795 56.708",
    stroke: "white",
    strokeWidth: 5.31331,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5805 51.4443C72.5774 49.5963 74.3183 44.8605 72.4689 40.8666C70.6196 36.8727 65.8802 35.1331 61.8833 36.9811C57.8863 38.8291 56.1454 43.5649 57.9948 47.5588C59.8442 51.5527 64.5835 53.2923 68.5805 51.4443Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2883 44.9063C57.2186 44.0931 57.2651 43.3265 57.4278 42.5598C58.6833 41.7234 60.1713 41.1891 61.7988 41.1426C66.4256 40.9568 70.3083 44.5578 70.4943 49.181C70.5176 49.5528 70.4943 49.9013 70.4711 50.2497C69.2388 51.2952 67.7043 51.9922 65.9606 52.1548C61.5431 52.5498 57.6836 49.2972 57.2883 44.9063Z",
    fill: "#1A237E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8268 52.169C34.2259 51.9515 37.6156 48.2118 37.3979 43.816C37.1802 39.4203 33.4376 36.0332 29.0386 36.2507C24.6395 36.4682 21.2499 40.208 21.4675 44.6037C21.6852 48.9994 25.4278 52.3865 29.8268 52.169Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1073 51.8521C26.3401 51.6198 25.6193 51.2713 24.9916 50.8531C24.6661 49.3663 24.7591 47.8097 25.2938 46.2763C26.8516 41.9319 31.6643 39.6783 36.0121 41.2349C36.3608 41.3511 36.6863 41.5137 36.9886 41.6531C37.5001 43.1864 37.5698 44.8824 37.0583 46.5319C35.7796 50.7602 31.3156 53.1299 27.1073 51.8521Z",
    fill: "#1A237E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6165 99.8981L40.153 110.422L40.4088 98.086L29.2953 103.453L36.1773 93.2072L23.9245 91.7203L35.2705 86.8182L25.7613 78.9424L37.9443 80.9637L34.2243 69.1848L43.3848 77.4788L46.6165 65.5605L49.825 77.4788L59.0088 69.1848L55.2655 80.9637L67.4485 78.9424L57.9625 86.8182L69.2853 91.7203L57.0325 93.2072L63.9378 103.453L52.801 98.086L53.0568 110.422L46.6165 99.8981Z",
    fill: "#57DD97"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemIcon);
export default __webpack_public_path__ + "static/media/RedeemIcon.32e1f5ddaa82440047d7439db923478e.svg";
export { ForwardRef as ReactComponent };